module.exports = __webpack_public_path__ + "assets/img/block-hover-b65cb1b9.png";